module.exports = __webpack_public_path__ + "img/index-spot-1.9e8f628a.png";